<template>
  <div class="route-view has-top dark">
    <h1 class="title">
      <span>{{ $t('bonus.bonusTitle') }}</span>
    </h1>
    <div v-if="isBonusActive" class="block">
      {{ $t('bonus.bonusType') }} {{ bonusType }}
      <button class="button small is-danger" @click="refreshAllSlot">
        {{ $t('bonus.cancelBtn') }}
      </button>
    </div>
    <div v-else class="block">
      <form @submit.prevent="modalPromotion">
        <div class="field">
          <div class="control">
            <input
              v-model="promotion"
              type="text"
              placeholder="รหัสโปรโมชั่น"
              class="input width-50"
              required
              v-uppercase
            />
            <button type="submit" class="button width-50 is-primary">
              {{ $t('bonus.searchBtn') }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="columns is-multiline is-centered">
      <div v-for="(bonus, index) in bonuses" :key="index" class="column">
        <div
          class="bonus"
          v-bind:style="{
            backgroundImage: `url(${url}${bonus.banners[0].image})`
          }"
        >
          <div v-if="bonus.userBonus.isActive === true" class="bonus-container">
            <img src="/images/current.png" class="image-corner" />
          </div>
          <div v-else>
            <div
              v-if="
                bonus.userBonus.received &&
                  ((bonus.type === 'limit' &&
                    bonus.userBonus.received.length >= bonus.maxReceived) ||
                    (bonus.type === 'day' &&
                      countReceiveInDay(bonus.userBonus.received) >=
                        bonus.maxReceived) ||
                    (bonus.type === 'week' &&
                      countReceiveInWeek(bonus.userBonus.received) >=
                        bonus.maxReceived))
              "
              class="bonus-container disabled"
            >
              <div class="bonus-content">
                <div class="bonus-title">
                  {{ $t('bonus.bonusReceived') }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="bonus-container blur"
              @click="modalBonus({ bonus })"
            >
              <div class="bonus-content">
                <div class="bonus-title">
                  {{ $t('bonus.bonusClick') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalBonus
      v-if="modalBonusActive"
      :is-active="modalBonusActive"
      :selected-bonus="selectedBonus"
      @closeModal="modalBonus"
    />
    <modalPromotion
      v-if="modalPromotionActive"
      :is-active="modalPromotionActive"
      :promotion="promotion"
      @closeModal="modalPromotion"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

// import apiWallet from '@/api/wallet'
import apiBonus from '@/api/bonus'

import { setLastSync } from '@/utils/sync'

import ModalBonus from '@/views/user/components/modals/Bonus'
import ModalPromotion from '@/views/user/components/modals/Promotion'
import i18n from '@/language'
export default {
  name: 'UserBonus',
  components: {
    ModalBonus,
    ModalPromotion
  },
  props: {
    page: String
  },
  data() {
    return {
      selectedBonus: {},
      bonuses: [],
      modalBonusActive: false,
      url: process.env.VUE_APP_BASE_API,
      bonusType: '',
      promotion: '',
      modalPromotionActive: false,
      isBonusActive: false
    }
  },
  created() {
    this.$emit('childinit', this.page)

    this.checkBonusActive()
  },
  async mounted() {
    this.getUserBonus()
  },
  methods: {
    async getUserBonus() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiBonus.getUserBonus()
          this.bonuses = data

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    async checkBonusActive() {
      const data = await apiBonus.checkBonusActive()
      this.isBonusActive = data.status
      this.bonusType = data.type
    },
    async refreshAllSlot() {
      setTimeout(async () => {
        try {
          // await apiWallet.refreshAllSlot()

          await this.checkMinimumBonus()
        } finally {
          setLastSync()
        }
      }, 200)
    },

    async checkMinimumBonus() {
      this.$buefy.dialog.confirm({
        title: i18n.t('bonus.cancelBonusConMsg'),
        message: `${i18n.t('bonus.cancelOneMsg')}<br>
        <span class="has-text-danger">
        <b>${i18n.t('bonus.cancelTwoMsg')}</b></span>`,
        confirmText: i18n.t('bonus.confirmMsg'),
        cancelText: i18n.t('bonus.cancelMsg'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          let loading
          try {
            loading = this.$loading.show()

            const data = await apiBonus.clearBonus()
            this.checkBonusActive()
            this.getUserBonus()

            loading.hide()

            this.$buefy.toast.open(data.message)
          } catch (error) {
            if (loading) loading.hide()
            this.$buefy.dialog.alert({
              title: i18n.t('bonus.cancelConBonusMsg'),
              message: error,
              confirmText: i18n.t('bonus.closeMsg'),
              type: 'is-danger',
              hasIcon: true
            })
          }
        }
      })

      // let loading = this.$loading.show()

      // try {
      //   const result = await apiBonus.checkMinimum()
      //   loading.hide()

      //   if (result === true) {
      //     this.$buefy.dialog.confirm({
      //       title: 'ยกเลิกเงื่อนไขโบนัส',
      //       message: 'คุณมียอดเงินรวมต่ำกว่าเงื่อนไข ต้องการยกเลิกโบนัสหรือไม่',
      //       confirmText: 'ต้องการ',
      //       cancelText: 'ไม่ต้องการ',
      //       type: 'is-danger',
      //       hasIcon: true,
      //       onConfirm: async () => {
      //         const data = await apiBonus.clearBonus()
      //         this.checkBonusActive()
      //         this.getUserBonus()
      //         this.$buefy.toast.open(data.message)
      //       }
      //     })
      //   }
      //   else {
      //     this.$buefy.dialog.alert({
      //       title: 'ยกเลิกเงื่อนไขโบนัส',
      //       message: 'คุณไม่สามารถยกเลิกโบนัสได้ เนื่องจากติดเงื่อนไขอยู่',
      //       confirmText: 'ปิด',
      //       type: 'is-danger',
      //       hasIcon: true
      //     })
      //   }
      // }
      // catch {
      //   loading.hide()
      // }
    },
    modalBonus({ bonus, isSaved }) {
      this.modalBonusActive = !this.modalBonusActive
      this.disabledBodyScroll(this.modalBonusActive)

      if (bonus) this.selectedBonus = bonus
      else this.selectedBonus = {}

      if (isSaved === true) {
        this.getUserBonus()
      }
    },
    modalPromotion(isSaved) {
      this.modalPromotionActive = !this.modalPromotionActive
      this.disabledBodyScroll(this.modalPromotionActive)

      if (isSaved === true) {
        this.getUserBonus()
      }
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    },
    countReceiveInDay(received) {
      const rev = _.filter(received, function(o) {
        return moment(o.updatedAt).isSame(moment(), 'day')
      })

      return rev.length
    },
    countReceiveInWeek(received) {
      const rev = _.filter(received, function(o) {
        return moment(o.updatedAt).isSame(moment(), 'week')
      })

      return rev.length
    }
  }
}
</script>

<style scoped lang="scss">
.gray-bg {
  background-color: #dfdfdf;
}
.bonus {
  position: relative;
  margin: auto;
  background-size: 100% 100%;
  border-radius: 10px;
  width: 300px;
  height: 300px;
  text-align: center;
  display: block;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  .bonus-container {
    position: absolute;
    color: #fff;
    bottom: 0;
    min-width: 100%;
    height: 100%;
    text-align: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: table;

    &.blur {
      background-color: rgba(0, 0, 0, 0.6);
    }

    &.disabled {
      background-color: rgba(0, 0, 0, 0.8);
    }

    .bonus-content {
      display: table-cell;
      vertical-align: top;
      padding-top: 20px;

      .bonus-title {
        font-size: 20px;
      }
    }

    img {
      &.image-corner {
        height: 80px;
        top: -5px;
        left: -8px;
        position: absolute;
      }
    }
  }
}

.control {
  text-align: right;

  .input {
    &.width-50 {
      width: 200px;
    }
  }
}

.button {
  margin-left: 10px;

  &.width-50 {
    width: 100px;
  }

  &.small {
    padding: 5px 10px !important;
    border-radius: 10px;
    height: fit-content;
  }
}

.block {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
